import { Home } from './home';

require('./home.scss');

export const myHome = {
  template: require('./home.html'),
  controllerAs: 'ctrl',
  controller: Home,
};
